export function slugify(input) {
  return input
    .toLowerCase() // convert to lowercase
    .replace(/[,&]/g, '') // remove commas and ampersands
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-') // collapse multiple hyphens
    .trim(); // remove leading/trailing whitespace
}

export function getBaseUrl(fullUrl) {
  try {
    const url = new URL(fullUrl);
    return url.origin; // returns protocol + hostname (and port if present)
  } catch (error) {
    console.error('Invalid URL:', error);
    return null;
  }
}

export function toSnakeCase(str) {
  return str
    .toLowerCase() // convert to lowercase
    .trim() // remove leading/trailing spaces
    .replace(/\s+/g, '_'); // replace spaces with underscores
}

// export function sortMenuChronologically(menuItems) {
//   return menuItems
//     .map((item) => {
//       let newItem = { ...item };

//       // Sort divisions (Expertise section)
//       if (newItem.content?.divisions) {
//         newItem.content.divisions = newItem.content.divisions
//           .map((div) => ({
//             ...div,
//             services: div.services
//               ? [...div.services].sort((a, b) => a.text.localeCompare(b.text))
//               : [],
//           }))
//           .sort((a, b) => a.title.localeCompare(b.title));
//       }

//       // Sort industries categories
//       if (newItem.content?.categories) {
//         newItem.content.categories = newItem.content.categories
//           .map((cat) => ({
//             ...cat,
//             items: cat.items
//               ? [...cat.items].sort((a, b) => a.localeCompare(b))
//               : [],
//           }))
//           .sort((a, b) => a.title.localeCompare(b.title));
//       }

//       // Sort software/training sections
//       if (newItem.content?.sections) {
//         newItem.content.sections = newItem.content.sections
//           .map((sec) => ({
//             ...sec,
//             items: sec.items
//               ? [...sec.items].sort((a, b) =>
//                   (a.text || '').localeCompare(b.text || '')
//                 )
//               : [],
//           }))
//           .sort((a, b) => a.title.localeCompare(b.title));
//       }

//       // Sort resource types
//       if (newItem.content?.resource_types) {
//         newItem.content.resource_types = [
//           ...newItem.content.resource_types,
//         ].sort((a, b) => a.text.localeCompare(b.text));
//       }

//       // Sort about_us sections
//       if (newItem.content?.sections) {
//         newItem.content.sections = newItem.content.sections
//           .map((sec) => ({
//             ...sec,
//             items: sec.items
//               ? [...sec.items].sort((a, b) =>
//                   (a.text || '').localeCompare(b.text || '')
//                 )
//               : [],
//           }))
//           .sort((a, b) => a.title.localeCompare(b.title));
//       }

//       // Sort locations regions
//       if (newItem.content?.regions) {
//         newItem.content.regions = newItem.content.regions
//           .map((region) => {
//             if (region.states) {
//               region.states = [...region.states].sort((a, b) =>
//                 a.localeCompare(b)
//               );
//             }
//             if (region.countries) {
//               region.countries = [...region.countries].sort((a, b) =>
//                 a.localeCompare(b)
//               );
//             }
//             return region;
//           })
//           .sort((a, b) => a.title.localeCompare(b.title));
//       }

//       return newItem;
//     })
//     .sort((a, b) => a.title.localeCompare(b.title)); // Top-level sorting
// }

export function sortNestedMenu(menuItems) {
  return menuItems.map((item) => {
    let newItem = { ...item };

    // Sort divisions (under Expertise)
    // if (newItem.content?.divisions) {
    //   newItem.content.divisions = newItem.content.divisions
    //     .map(div => ({
    //       ...div,
    //       services: div.services
    //         ? [...div.services].sort((a, b) =>
    //             a.text.localeCompare(b.text)
    //           )
    //         : [],
    //     }))
    //     .sort((a, b) => a.title.localeCompare(b.title));
    // }

    // Sort industries categories + their items
    // if (newItem.content?.categories) {
    //   newItem.content.categories = newItem.content.categories
    //     .map((cat) => ({
    //       ...cat,
    //       items: cat.items
    //         ? [...cat.items].sort((a, b) => a.localeCompare(b))
    //         : [],
    //     }))
    //     .sort((a, b) => a.title.localeCompare(b.title));
    // }

    // Sort software/training/about_us sections + their items
    // if (newItem.content?.sections) {
    //   newItem.content.sections = newItem.content.sections
    //     .map(sec => ({
    //       ...sec,
    //       items: sec.items
    //         ? [...sec.items].sort((a, b) =>
    //             (a.text || "").localeCompare(b.text || "")
    //           )
    //         : [],
    //     }))
    //     .sort((a, b) => a.title.localeCompare(b.title));
    // }

    // Sort resource types (Resources section)
    // if (newItem.content?.resource_types) {
    //   newItem.content.resource_types = [...newItem.content.resource_types].sort(
    //     (a, b) => a.text.localeCompare(b.text)
    //   );
    // }

    // Sort locations regions + nested states/countries
    // if (newItem.content?.regions) {
    //   newItem.content.regions = newItem.content.regions
    //     .map((region) => {
    //       if (region.states) {
    //         region.states = [...region.states].sort((a, b) =>
    //           a.localeCompare(b)
    //         );
    //       }
    //       if (region.countries) {
    //         region.countries = [...region.countries].sort((a, b) =>
    //           a.localeCompare(b)
    //         );
    //       }
    //       return region;
    //     })
    //     .sort((a, b) => a.title.localeCompare(b.title));
    // }

    return newItem; // Top-level order remains unchanged
  });
}
